import { initialCompanyOutletState } from "../../redux/companyOutlet/defaultState";
import { IBillingCompanyContextState } from "./BillingCompanyProvider.types";

export const defaultBillingCompanyContextState: IBillingCompanyContextState = {
	comapny: initialCompanyOutletState["companyOutlet"]["data"],
};
